import { stylePropsAll } from "@tamagui/helpers";
import { createComponent } from "./createComponent";
import { mergeVariants } from "./helpers/extendStaticConfig";
import { ReactNativeStaticConfigs } from "./setupReactNative";
function styled(ComponentIn, options, staticExtractionOptions) {
  if (process.env.NODE_ENV !== "production") {
    if (!ComponentIn) {
      throw new Error(`No component given to styled()`);
    }
    if (options == null ? void 0 : options.variants) {
      for (const key in options.variants) {
        if (key in stylePropsAll) {
          console.error(
            `Invalid variant key overlaps with style key: ${key}. Tamagui prevents defining variants that use valid style keys to reduce complexity and confusion.`
          );
        }
      }
    }
  }
  const parentStaticConfig = "staticConfig" in ComponentIn ? ComponentIn.staticConfig : null;
  const isPlainStyledComponent = !!parentStaticConfig && !(parentStaticConfig.isReactNative || parentStaticConfig.isHOC);
  let Component = isPlainStyledComponent ? ComponentIn : (parentStaticConfig == null ? void 0 : parentStaticConfig.Component) || ComponentIn;
  const isReactNative = Boolean(
    ReactNativeStaticConfigs.has(Component) || (staticExtractionOptions == null ? void 0 : staticExtractionOptions.isReactNative) || ReactNativeStaticConfigs.has(parentStaticConfig == null ? void 0 : parentStaticConfig.Component) || (parentStaticConfig == null ? void 0 : parentStaticConfig.isReactNative)
  );
  const staticConfigProps = (() => {
    if (options) {
      let {
        variants,
        name,
        defaultVariants,
        acceptsClassName: acceptsClassNameProp,
        context,
        ...defaultProps
      } = options;
      if (parentStaticConfig) {
        defaultProps = {
          ...parentStaticConfig.defaultProps,
          ...defaultProps,
          ...defaultVariants
        };
      }
      if (defaultVariants) {
        defaultProps = {
          ...defaultProps,
          ...defaultVariants
        };
      }
      if (parentStaticConfig == null ? void 0 : parentStaticConfig.isHOC) {
        variants = mergeVariants(parentStaticConfig.variants, variants);
      }
      const nativeConf = isReactNative && ReactNativeStaticConfigs.get(Component) || null;
      const isText = Boolean(
        (staticExtractionOptions == null ? void 0 : staticExtractionOptions.isText) || (parentStaticConfig == null ? void 0 : parentStaticConfig.isText)
      );
      const acceptsClassName = acceptsClassNameProp ?? (isPlainStyledComponent || isReactNative || (parentStaticConfig == null ? void 0 : parentStaticConfig.isHOC) && (parentStaticConfig == null ? void 0 : parentStaticConfig.acceptsClassName));
      const conf = {
        ...staticExtractionOptions,
        ...!isPlainStyledComponent && {
          Component
        },
        // this type gets messed up by options?: Partial<GetProps<ParentComponent>> above
        // take away the Partial<> and it's fine
        variants,
        defaultProps,
        defaultVariants,
        componentName: name || (parentStaticConfig == null ? void 0 : parentStaticConfig.componentName),
        isReactNative,
        isText,
        acceptsClassName,
        context,
        ...nativeConf
      };
      if (defaultProps.children || !acceptsClassName) {
        conf.neverFlatten = true;
      }
      return conf;
    }
  })();
  const component = createComponent(staticConfigProps || {}, Component);
  for (const key in ComponentIn) {
    if (key in component)
      continue;
    component[key] = ComponentIn[key];
  }
  return component;
}
export {
  styled
};
//# sourceMappingURL=styled.js.map
